import { TransactionsCategory } from './transactions';

// eslint-disable-next-line import/prefer-default-export
export const CFDIListActions = {
  VIEW_PDF: 'VIEW_PDF',
  SEND_EMAIL: 'SEND_EMAIL',
  SEND_WHATSAPP: 'SEND_WHATSAPP',
  CANCEL_INVOICE: 'CANCEL_INVOICE',
  CANCEL_RECEIPT: 'CANCEL_RECEIPT'
};

export const InvoiceTypes = {
  INCOME: 'INCOME',
  EXPENSE: 'EXPENSE',
  PAYMENT: 'PAYMENT',
  PAYROLL: 'PAYROLL',
  TRANSFER: 'TRANSFER'
};

export const categoryOptions = [
  TransactionsCategory.RENT,
  TransactionsCategory.UPFRONT_RENT,
  TransactionsCategory.RESIDUAL,
  TransactionsCategory.INITIAL_PAYMENT
];

export const CFDICancelMotives = [
  {
    key: '01',
    name: 'ISSUED_WITH_ERRORS_WITH_RELATION'
  },
  {
    key: '02',
    name: 'ISSUED_WITH_ERRORS_WITHOUT_RELATION'
  },
  { key: '03', name: 'OPERATION_NOT_COMPLETED' },
  {
    key: '04',
    name: 'NOMINATIVE_OPERATION_RELATED_TO_GLOBAL_INVOICE'
  }
];

export const IssuerType = {
  RECEIVING: 'RECEIVING',
  ISSUING: 'ISSUING'
};

export const PaymentMethod = {
  PPD: 'PPD',
  PUE: 'PUE'
};

export const CDFIDocumentFormat = {
  PDF: 'PDF',
  XML: 'XML'
};

export const getTransactionCategoryLabels = t => [
  { key: TransactionsCategory.RENT, name: t('TRANSACTION.CATEGORY.RENT') },
  {
    key: TransactionsCategory.SURCHARGE,
    name: t('TRANSACTION.CATEGORY.SURCHARGE')
  },
  {
    key: TransactionsCategory.INTEREST,
    name: t('TRANSACTION.CATEGORY.INTEREST')
  },
  {
    key: TransactionsCategory.DISCOUNT,
    name: t('TRANSACTION.CATEGORY.DISCOUNT')
  },
  { key: TransactionsCategory.OTHER, name: t('TRANSACTION.CATEGORY.OTHER') },
  {
    key: TransactionsCategory.CAPITAL_CONTRIBUTION,
    name: t('TRANSACTION.CATEGORY.CAPITAL_CONTRIBUTION')
  },
  {
    key: TransactionsCategory.INITIAL_PAYMENT,
    name: t('TRANSACTION.CATEGORY.INITIAL_PAYMENT')
  },
  {
    key: TransactionsCategory.RESIDUAL,
    name: t('TRANSACTION.CATEGORY.RESIDUAL')
  },
  {
    key: TransactionsCategory.UPFRONT_RENT,
    name: t('TRANSACTION.CATEGORY.UPFRONT_RENT')
  }
];

export const getCancelWarningKey = (
  isOlderThan72Hours,
  isAmountMoreThan5000
) => {
  if (isOlderThan72Hours && isAmountMoreThan5000) {
    return 'CFDI_FORM.CANCEL_MORE_THAN_72_HOURS_AND_5000_PESOS';
  }
  if (isOlderThan72Hours) {
    return 'CFDI_FORM.CANCEL_MORE_THAN_72_HOURS_OLD';
  }
  if (isAmountMoreThan5000) {
    return 'CFDI_FORM.CANCEL_MORE_THAN_5000_PESOS';
  }
  return null;
};

export const CancellationMotive = {
  ISSUED_WITH_ERRORS_WITH_RELATION: '01',
  ISSUED_WITH_ERRORS_WITHOUT_RELATION: '02',
  OPERATION_NOT_COMPLETED: '03',
  NOMINATIVE_OPERATION_RELATED_TO_GLOBAL_INVOICE: '04'
};

export const invoiceTypeLabels = {
  INCOME: 'Ingreso',
  EXPENSE: 'Gasto',
  PAYMENT: 'Pago',
  PAYROLL: 'Nómina',
  TRANSFER: 'Transferencia'
};

export const CdfiStatus = {
  VALID: 'VALID',
  PENDING_CANCELLATION: 'PENDING_CANCELLATION',
  CANCELLED: 'CANCELLED'
};
